"use strict";
/* eslint-disable */
/**
 * This file was automatically generated by json-schema-to-typescript.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
 * and run json-schema-to-typescript to regenerate this file.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.createOfferContext_2_0_0 = exports.createOfferContext_1_0_0 = exports.createLuxPlus_1_0_0 = exports.createLoyalty_1_0_1 = exports.createLoyalty_1_0_0 = exports.createListItem_1_0_0 = exports.createItem_1_1_2 = exports.createItem_1_1_1 = exports.createItem_1_1_0 = exports.createItem_1_0_0 = exports.createImage_1_0_0 = exports.createGoogleAnalytics_1_0_0 = exports.createFilter_1_0_0 = exports.createExperimentContext_1_0_0 = exports.createEmailSendContext_1_0_2 = exports.createEmailSendContext_1_0_1 = exports.createEmailSendContext_1_0_0 = exports.createEmailOpenContext_1_0_2 = exports.createEmailOpenContext_1_0_1 = exports.createEmailOpenContext_1_0_0 = exports.createEmailClickContext_1_0_4 = exports.createEmailClickContext_1_0_3 = exports.createEmailClickContext_1_0_2 = exports.createEmailClickContext_1_0_1 = exports.createEmailClickContext_1_0_0 = exports.createDestinationImpression_1_0_0 = exports.createDestinationClick_1_0_0 = exports.createDestination_1_0_0 = exports.createClientEvent_1_0_0 = exports.createChatWidget_1_0_0 = exports.createCartOrderLink_1_0_0 = exports.createCartContext_1_0_0 = exports.createCart_1_0_0 = exports.createCarouselImageImpression_1_0_0 = exports.createBrand_1_0_0 = exports.createBotDetection_1_0_0 = exports.createBookingCancellation_1_0_0 = exports.createBeginCheckout_1_0_0 = exports.createAuditLog_1_0_0 = exports.createAppContext_1_0_0 = exports.createAddToCart_1_0_0 = exports.createActivateAbTest_1_0_0 = exports.createAccommodation_1_0_0 = exports.createAbandonedCart_1_2_0 = exports.createAbandonedCart_1_1_3 = exports.createAbandonedCart_1_1_2 = exports.createAbandonedCart_1_1_1 = exports.createAbandonedCart_1_1_0 = exports.createAbandonedCart_1_0_1 = exports.createAbandonedCart_1_0_0 = void 0;
exports.createTypeaheadItem_1_0_0 = exports.createTypeaheadEvent_1_0_0 = exports.createTPFMEmailSend_1_0_2 = exports.createTPFMEmailSend_1_0_1 = exports.createTPFMEmailSend_1_0_0 = exports.createSurvey_1_0_0 = exports.createSort_1_0_0 = exports.createSignupSuccess_1_0_0 = exports.createSigninSuccess_1_0_0 = exports.createSearchSession_1_0_0 = exports.createSearchResultClick_1_0_0 = exports.createSearchContext_1_0_3 = exports.createSearchContext_1_0_2 = exports.createSearchContext_1_0_1 = exports.createSearchContext_1_0_0 = exports.createSearch_3_0_0 = exports.createSearch_2_0_0 = exports.createSearch_1_0_2 = exports.createSearch_1_0_1 = exports.createSearch_1_0_0 = exports.createRegion_1_0_0 = exports.createPurchaseSuccess_1_0_0 = exports.createPromotionView_1_0_0 = exports.createPromotionDisplayCheck_1_0_0 = exports.createPromotionCode_1_0_0 = exports.createPromotionClick_1_0_0 = exports.createPromotion_1_0_0 = exports.createProductImpressionContext_1_0_1 = exports.createProductImpressionContext_1_0_0 = exports.createProductImpression_1_0_3 = exports.createProductImpression_1_0_2 = exports.createProductImpression_1_0_1 = exports.createProductImpression_1_0_0 = exports.createProductClickContext_1_0_1 = exports.createProductClickContext_1_0_0 = exports.createProductClick_1_0_2 = exports.createProductClick_1_0_1 = exports.createProductClick_1_0_0 = exports.createPerfectMatchCommunicationSend_1_0_0 = exports.createPayment_1_0_0 = exports.createPageViewContext_1_0_0 = exports.createPage_1_0_1 = exports.createPage_1_0_0 = exports.createPackageOptionImpression_1_0_0 = exports.createPackageOption_1_0_1 = exports.createPackageOption_1_0_0 = exports.createOrder_1_0_0 = exports.createOptimizelyEventContext_1_0_0 = exports.createOfferContext_2_1_1 = exports.createOfferContext_2_1_0 = void 0;
exports.createZeroSearchResults_1_0_0 = exports.createVendor_1_0_0 = exports.createUtms_1_0_0 = exports.createUserPurchaseCount_1_0_0 = exports.createUser_1_0_0 = exports.createUpgrade_1_0_0 = exports.createTypeaheadQuery_1_0_0 = exports.createTypeaheadItem_2_0_0 = exports.createTypeaheadItem_1_0_1 = void 0;
function createAbandonedCart_1_0_0(data) {
    return {
        schema: "iglu:com.luxgroup/abandoned_cart/jsonschema/1-0-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createAbandonedCart_1_0_0 = createAbandonedCart_1_0_0;
function createAbandonedCart_1_0_1(data) {
    return {
        schema: "iglu:com.luxgroup/abandoned_cart/jsonschema/1-0-1",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createAbandonedCart_1_0_1 = createAbandonedCart_1_0_1;
function createAbandonedCart_1_1_0(data) {
    return {
        schema: "iglu:com.luxgroup/abandoned_cart/jsonschema/1-1-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createAbandonedCart_1_1_0 = createAbandonedCart_1_1_0;
function createAbandonedCart_1_1_1(data) {
    return {
        schema: "iglu:com.luxgroup/abandoned_cart/jsonschema/1-1-1",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createAbandonedCart_1_1_1 = createAbandonedCart_1_1_1;
function createAbandonedCart_1_1_2(data) {
    return {
        schema: "iglu:com.luxgroup/abandoned_cart/jsonschema/1-1-2",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createAbandonedCart_1_1_2 = createAbandonedCart_1_1_2;
function createAbandonedCart_1_1_3(data) {
    return {
        schema: "iglu:com.luxgroup/abandoned_cart/jsonschema/1-1-3",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createAbandonedCart_1_1_3 = createAbandonedCart_1_1_3;
function createAbandonedCart_1_2_0(data) {
    return {
        schema: "iglu:com.luxgroup/abandoned_cart/jsonschema/1-2-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createAbandonedCart_1_2_0 = createAbandonedCart_1_2_0;
function createAccommodation_1_0_0(data) {
    return {
        schema: "iglu:com.luxgroup/accommodation/jsonschema/1-0-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createAccommodation_1_0_0 = createAccommodation_1_0_0;
function createActivateAbTest_1_0_0(data) {
    return {
        schema: "iglu:com.luxgroup/activate_ab_test/jsonschema/1-0-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createActivateAbTest_1_0_0 = createActivateAbTest_1_0_0;
function createAddToCart_1_0_0(data) {
    return {
        schema: "iglu:com.luxgroup/add_to_cart/jsonschema/1-0-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createAddToCart_1_0_0 = createAddToCart_1_0_0;
function createAppContext_1_0_0(data) {
    return {
        schema: "iglu:com.luxgroup/app_context/jsonschema/1-0-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createAppContext_1_0_0 = createAppContext_1_0_0;
function createAuditLog_1_0_0(data) {
    return {
        schema: "iglu:com.luxgroup/audit_log/jsonschema/1-0-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createAuditLog_1_0_0 = createAuditLog_1_0_0;
function createBeginCheckout_1_0_0(data) {
    return {
        schema: "iglu:com.luxgroup/begin_checkout/jsonschema/1-0-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createBeginCheckout_1_0_0 = createBeginCheckout_1_0_0;
function createBookingCancellation_1_0_0(data) {
    return {
        schema: "iglu:com.luxgroup/booking_cancellation/jsonschema/1-0-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createBookingCancellation_1_0_0 = createBookingCancellation_1_0_0;
function createBotDetection_1_0_0(data) {
    return {
        schema: "iglu:com.luxgroup/bot_detection/jsonschema/1-0-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createBotDetection_1_0_0 = createBotDetection_1_0_0;
function createBrand_1_0_0(data) {
    return {
        schema: "iglu:com.luxgroup/brand/jsonschema/1-0-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createBrand_1_0_0 = createBrand_1_0_0;
function createCarouselImageImpression_1_0_0(data) {
    return {
        schema: "iglu:com.luxgroup/carousel_image_impression/jsonschema/1-0-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createCarouselImageImpression_1_0_0 = createCarouselImageImpression_1_0_0;
function createCart_1_0_0(data) {
    return {
        schema: "iglu:com.luxgroup/cart/jsonschema/1-0-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createCart_1_0_0 = createCart_1_0_0;
function createCartContext_1_0_0(data) {
    return {
        schema: "iglu:com.luxgroup/cart_context/jsonschema/1-0-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createCartContext_1_0_0 = createCartContext_1_0_0;
function createCartOrderLink_1_0_0(data) {
    return {
        schema: "iglu:com.luxgroup/cart_order_link/jsonschema/1-0-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createCartOrderLink_1_0_0 = createCartOrderLink_1_0_0;
function createChatWidget_1_0_0(data) {
    return {
        schema: "iglu:com.luxgroup/chat_widget/jsonschema/1-0-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createChatWidget_1_0_0 = createChatWidget_1_0_0;
function createClientEvent_1_0_0(data) {
    return {
        schema: "iglu:com.luxgroup/client_event/jsonschema/1-0-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createClientEvent_1_0_0 = createClientEvent_1_0_0;
function createDestination_1_0_0(data) {
    return {
        schema: "iglu:com.luxgroup/destination/jsonschema/1-0-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createDestination_1_0_0 = createDestination_1_0_0;
function createDestinationClick_1_0_0(data) {
    return {
        schema: "iglu:com.luxgroup/destination_click/jsonschema/1-0-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createDestinationClick_1_0_0 = createDestinationClick_1_0_0;
function createDestinationImpression_1_0_0(data) {
    return {
        schema: "iglu:com.luxgroup/destination_impression/jsonschema/1-0-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createDestinationImpression_1_0_0 = createDestinationImpression_1_0_0;
function createEmailClickContext_1_0_0(data) {
    return {
        schema: "iglu:com.luxgroup/email_click_context/jsonschema/1-0-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createEmailClickContext_1_0_0 = createEmailClickContext_1_0_0;
function createEmailClickContext_1_0_1(data) {
    return {
        schema: "iglu:com.luxgroup/email_click_context/jsonschema/1-0-1",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createEmailClickContext_1_0_1 = createEmailClickContext_1_0_1;
function createEmailClickContext_1_0_2(data) {
    return {
        schema: "iglu:com.luxgroup/email_click_context/jsonschema/1-0-2",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createEmailClickContext_1_0_2 = createEmailClickContext_1_0_2;
function createEmailClickContext_1_0_3(data) {
    return {
        schema: "iglu:com.luxgroup/email_click_context/jsonschema/1-0-3",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createEmailClickContext_1_0_3 = createEmailClickContext_1_0_3;
function createEmailClickContext_1_0_4(data) {
    return {
        schema: "iglu:com.luxgroup/email_click_context/jsonschema/1-0-4",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createEmailClickContext_1_0_4 = createEmailClickContext_1_0_4;
function createEmailOpenContext_1_0_0(data) {
    return {
        schema: "iglu:com.luxgroup/email_open_context/jsonschema/1-0-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createEmailOpenContext_1_0_0 = createEmailOpenContext_1_0_0;
function createEmailOpenContext_1_0_1(data) {
    return {
        schema: "iglu:com.luxgroup/email_open_context/jsonschema/1-0-1",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createEmailOpenContext_1_0_1 = createEmailOpenContext_1_0_1;
function createEmailOpenContext_1_0_2(data) {
    return {
        schema: "iglu:com.luxgroup/email_open_context/jsonschema/1-0-2",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createEmailOpenContext_1_0_2 = createEmailOpenContext_1_0_2;
function createEmailSendContext_1_0_0(data) {
    return {
        schema: "iglu:com.luxgroup/email_send_context/jsonschema/1-0-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createEmailSendContext_1_0_0 = createEmailSendContext_1_0_0;
function createEmailSendContext_1_0_1(data) {
    return {
        schema: "iglu:com.luxgroup/email_send_context/jsonschema/1-0-1",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createEmailSendContext_1_0_1 = createEmailSendContext_1_0_1;
function createEmailSendContext_1_0_2(data) {
    return {
        schema: "iglu:com.luxgroup/email_send_context/jsonschema/1-0-2",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createEmailSendContext_1_0_2 = createEmailSendContext_1_0_2;
function createExperimentContext_1_0_0(data) {
    return {
        schema: "iglu:com.luxgroup/experiments_context/jsonschema/1-0-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createExperimentContext_1_0_0 = createExperimentContext_1_0_0;
function createFilter_1_0_0(data) {
    return {
        schema: "iglu:com.luxgroup/filter/jsonschema/1-0-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createFilter_1_0_0 = createFilter_1_0_0;
function createGoogleAnalytics_1_0_0(data) {
    return {
        schema: "iglu:com.luxgroup/google_analytics/jsonschema/1-0-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createGoogleAnalytics_1_0_0 = createGoogleAnalytics_1_0_0;
function createImage_1_0_0(data) {
    return {
        schema: "iglu:com.luxgroup/image/jsonschema/1-0-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createImage_1_0_0 = createImage_1_0_0;
function createItem_1_0_0(data) {
    return {
        schema: "iglu:com.luxgroup/item/jsonschema/1-0-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createItem_1_0_0 = createItem_1_0_0;
function createItem_1_1_0(data) {
    return {
        schema: "iglu:com.luxgroup/item/jsonschema/1-1-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createItem_1_1_0 = createItem_1_1_0;
function createItem_1_1_1(data) {
    return {
        schema: "iglu:com.luxgroup/item/jsonschema/1-1-1",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createItem_1_1_1 = createItem_1_1_1;
function createItem_1_1_2(data) {
    return {
        schema: "iglu:com.luxgroup/item/jsonschema/1-1-2",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createItem_1_1_2 = createItem_1_1_2;
function createListItem_1_0_0(data) {
    return {
        schema: "iglu:com.luxgroup/list_item/jsonschema/1-0-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createListItem_1_0_0 = createListItem_1_0_0;
function createLoyalty_1_0_0(data) {
    return {
        schema: "iglu:com.luxgroup/loyalty/jsonschema/1-0-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createLoyalty_1_0_0 = createLoyalty_1_0_0;
function createLoyalty_1_0_1(data) {
    return {
        schema: "iglu:com.luxgroup/loyalty/jsonschema/1-0-1",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createLoyalty_1_0_1 = createLoyalty_1_0_1;
function createLuxPlus_1_0_0(data) {
    return {
        schema: "iglu:com.luxgroup/luxplus/jsonschema/1-0-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createLuxPlus_1_0_0 = createLuxPlus_1_0_0;
function createOfferContext_1_0_0(data) {
    return {
        schema: "iglu:com.luxgroup/offer_context/jsonschema/1-0-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createOfferContext_1_0_0 = createOfferContext_1_0_0;
function createOfferContext_2_0_0(data) {
    return {
        schema: "iglu:com.luxgroup/offer_context/jsonschema/2-0-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createOfferContext_2_0_0 = createOfferContext_2_0_0;
function createOfferContext_2_1_0(data) {
    return {
        schema: "iglu:com.luxgroup/offer_context/jsonschema/2-1-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createOfferContext_2_1_0 = createOfferContext_2_1_0;
function createOfferContext_2_1_1(data) {
    return {
        schema: "iglu:com.luxgroup/offer_context/jsonschema/2-1-1",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createOfferContext_2_1_1 = createOfferContext_2_1_1;
function createOptimizelyEventContext_1_0_0(data) {
    return {
        schema: "iglu:com.luxgroup/optimizely_event_context/jsonschema/1-0-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createOptimizelyEventContext_1_0_0 = createOptimizelyEventContext_1_0_0;
function createOrder_1_0_0(data) {
    return {
        schema: "iglu:com.luxgroup/order/jsonschema/1-0-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createOrder_1_0_0 = createOrder_1_0_0;
function createPackageOption_1_0_0(data) {
    return {
        schema: "iglu:com.luxgroup/package_option/jsonschema/1-0-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createPackageOption_1_0_0 = createPackageOption_1_0_0;
function createPackageOption_1_0_1(data) {
    return {
        schema: "iglu:com.luxgroup/package_option/jsonschema/1-0-1",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createPackageOption_1_0_1 = createPackageOption_1_0_1;
function createPackageOptionImpression_1_0_0(data) {
    return {
        schema: "iglu:com.luxgroup/package_option_impression/jsonschema/1-0-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createPackageOptionImpression_1_0_0 = createPackageOptionImpression_1_0_0;
function createPage_1_0_0(data) {
    return {
        schema: "iglu:com.luxgroup/page/jsonschema/1-0-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createPage_1_0_0 = createPage_1_0_0;
function createPage_1_0_1(data) {
    return {
        schema: "iglu:com.luxgroup/page/jsonschema/1-0-1",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createPage_1_0_1 = createPage_1_0_1;
function createPageViewContext_1_0_0(data) {
    return {
        schema: "iglu:com.luxgroup/page_view_context/jsonschema/1-0-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createPageViewContext_1_0_0 = createPageViewContext_1_0_0;
function createPayment_1_0_0(data) {
    return {
        schema: "iglu:com.luxgroup/payment/jsonschema/1-0-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createPayment_1_0_0 = createPayment_1_0_0;
function createPerfectMatchCommunicationSend_1_0_0(data) {
    return {
        schema: "iglu:com.luxgroup/perfect_match_communication_send/jsonschema/1-0-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createPerfectMatchCommunicationSend_1_0_0 = createPerfectMatchCommunicationSend_1_0_0;
function createProductClick_1_0_0(data) {
    return {
        schema: "iglu:com.luxgroup/product_click/jsonschema/1-0-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createProductClick_1_0_0 = createProductClick_1_0_0;
function createProductClick_1_0_1(data) {
    return {
        schema: "iglu:com.luxgroup/product_click/jsonschema/1-0-1",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createProductClick_1_0_1 = createProductClick_1_0_1;
function createProductClick_1_0_2(data) {
    return {
        schema: "iglu:com.luxgroup/product_click/jsonschema/1-0-2",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createProductClick_1_0_2 = createProductClick_1_0_2;
function createProductClickContext_1_0_0(data) {
    return {
        schema: "iglu:com.luxgroup/product_click_context/jsonschema/1-0-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createProductClickContext_1_0_0 = createProductClickContext_1_0_0;
function createProductClickContext_1_0_1(data) {
    return {
        schema: "iglu:com.luxgroup/product_click_context/jsonschema/1-0-1",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createProductClickContext_1_0_1 = createProductClickContext_1_0_1;
function createProductImpression_1_0_0(data) {
    return {
        schema: "iglu:com.luxgroup/product_impression/jsonschema/1-0-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createProductImpression_1_0_0 = createProductImpression_1_0_0;
function createProductImpression_1_0_1(data) {
    return {
        schema: "iglu:com.luxgroup/product_impression/jsonschema/1-0-1",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createProductImpression_1_0_1 = createProductImpression_1_0_1;
function createProductImpression_1_0_2(data) {
    return {
        schema: "iglu:com.luxgroup/product_impression/jsonschema/1-0-2",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createProductImpression_1_0_2 = createProductImpression_1_0_2;
function createProductImpression_1_0_3(data) {
    return {
        schema: "iglu:com.luxgroup/product_impression/jsonschema/1-0-3",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createProductImpression_1_0_3 = createProductImpression_1_0_3;
function createProductImpressionContext_1_0_0(data) {
    return {
        schema: "iglu:com.luxgroup/product_impression_context/jsonschema/1-0-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createProductImpressionContext_1_0_0 = createProductImpressionContext_1_0_0;
function createProductImpressionContext_1_0_1(data) {
    return {
        schema: "iglu:com.luxgroup/product_impression_context/jsonschema/1-0-1",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createProductImpressionContext_1_0_1 = createProductImpressionContext_1_0_1;
function createPromotion_1_0_0(data) {
    return {
        schema: "iglu:com.luxgroup/promotion/jsonschema/1-0-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createPromotion_1_0_0 = createPromotion_1_0_0;
function createPromotionClick_1_0_0(data) {
    return {
        schema: "iglu:com.luxgroup/promotion_click/jsonschema/1-0-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createPromotionClick_1_0_0 = createPromotionClick_1_0_0;
function createPromotionCode_1_0_0(data) {
    return {
        schema: "iglu:com.luxgroup/promotion_code/jsonschema/1-0-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createPromotionCode_1_0_0 = createPromotionCode_1_0_0;
function createPromotionDisplayCheck_1_0_0(data) {
    return {
        schema: "iglu:com.luxgroup/promotion_display_check/jsonschema/1-0-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createPromotionDisplayCheck_1_0_0 = createPromotionDisplayCheck_1_0_0;
function createPromotionView_1_0_0(data) {
    return {
        schema: "iglu:com.luxgroup/promotion_view/jsonschema/1-0-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createPromotionView_1_0_0 = createPromotionView_1_0_0;
function createPurchaseSuccess_1_0_0(data) {
    return {
        schema: "iglu:com.luxgroup/purchase_success/jsonschema/1-0-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createPurchaseSuccess_1_0_0 = createPurchaseSuccess_1_0_0;
function createRegion_1_0_0(data) {
    return {
        schema: "iglu:com.luxgroup/region/jsonschema/1-0-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createRegion_1_0_0 = createRegion_1_0_0;
function createSearch_1_0_0(data) {
    return {
        schema: "iglu:com.luxgroup/search/jsonschema/1-0-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createSearch_1_0_0 = createSearch_1_0_0;
function createSearch_1_0_1(data) {
    return {
        schema: "iglu:com.luxgroup/search/jsonschema/1-0-1",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createSearch_1_0_1 = createSearch_1_0_1;
function createSearch_1_0_2(data) {
    return {
        schema: "iglu:com.luxgroup/search/jsonschema/1-0-2",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createSearch_1_0_2 = createSearch_1_0_2;
function createSearch_2_0_0(data) {
    return {
        schema: "iglu:com.luxgroup/search/jsonschema/2-0-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createSearch_2_0_0 = createSearch_2_0_0;
function createSearch_3_0_0(data) {
    return {
        schema: "iglu:com.luxgroup/search/jsonschema/3-0-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createSearch_3_0_0 = createSearch_3_0_0;
function createSearchContext_1_0_0(data) {
    return {
        schema: "iglu:com.luxgroup/search_context/jsonschema/1-0-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createSearchContext_1_0_0 = createSearchContext_1_0_0;
function createSearchContext_1_0_1(data) {
    return {
        schema: "iglu:com.luxgroup/search_context/jsonschema/1-0-1",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createSearchContext_1_0_1 = createSearchContext_1_0_1;
function createSearchContext_1_0_2(data) {
    return {
        schema: "iglu:com.luxgroup/search_context/jsonschema/1-0-2",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createSearchContext_1_0_2 = createSearchContext_1_0_2;
function createSearchContext_1_0_3(data) {
    return {
        schema: "iglu:com.luxgroup/search_context/jsonschema/1-0-3",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createSearchContext_1_0_3 = createSearchContext_1_0_3;
function createSearchResultClick_1_0_0(data) {
    return {
        schema: "iglu:com.luxgroup/search_result_click/jsonschema/1-0-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createSearchResultClick_1_0_0 = createSearchResultClick_1_0_0;
function createSearchSession_1_0_0(data) {
    return {
        schema: "iglu:com.luxgroup/search_session/jsonschema/1-0-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createSearchSession_1_0_0 = createSearchSession_1_0_0;
function createSigninSuccess_1_0_0(data) {
    return {
        schema: "iglu:com.luxgroup/signin_success/jsonschema/1-0-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createSigninSuccess_1_0_0 = createSigninSuccess_1_0_0;
function createSignupSuccess_1_0_0(data) {
    return {
        schema: "iglu:com.luxgroup/signup_success/jsonschema/1-0-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createSignupSuccess_1_0_0 = createSignupSuccess_1_0_0;
function createSort_1_0_0(data) {
    return {
        schema: "iglu:com.luxgroup/sort/jsonschema/1-0-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createSort_1_0_0 = createSort_1_0_0;
function createSurvey_1_0_0(data) {
    return {
        schema: "iglu:com.luxgroup/survey/jsonschema/1-0-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createSurvey_1_0_0 = createSurvey_1_0_0;
function createTPFMEmailSend_1_0_0(data) {
    return {
        schema: "iglu:com.luxgroup/tpfm_email_send/jsonschema/1-0-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createTPFMEmailSend_1_0_0 = createTPFMEmailSend_1_0_0;
function createTPFMEmailSend_1_0_1(data) {
    return {
        schema: "iglu:com.luxgroup/tpfm_email_send/jsonschema/1-0-1",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createTPFMEmailSend_1_0_1 = createTPFMEmailSend_1_0_1;
function createTPFMEmailSend_1_0_2(data) {
    return {
        schema: "iglu:com.luxgroup/tpfm_email_send/jsonschema/1-0-2",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createTPFMEmailSend_1_0_2 = createTPFMEmailSend_1_0_2;
function createTypeaheadEvent_1_0_0(data) {
    return {
        schema: "iglu:com.luxgroup/typeahead_event/jsonschema/1-0-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createTypeaheadEvent_1_0_0 = createTypeaheadEvent_1_0_0;
function createTypeaheadItem_1_0_0(data) {
    return {
        schema: "iglu:com.luxgroup/typeahead_item/jsonschema/1-0-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createTypeaheadItem_1_0_0 = createTypeaheadItem_1_0_0;
function createTypeaheadItem_1_0_1(data) {
    return {
        schema: "iglu:com.luxgroup/typeahead_item/jsonschema/1-0-1",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createTypeaheadItem_1_0_1 = createTypeaheadItem_1_0_1;
function createTypeaheadItem_2_0_0(data) {
    return {
        schema: "iglu:com.luxgroup/typeahead_item/jsonschema/2-0-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createTypeaheadItem_2_0_0 = createTypeaheadItem_2_0_0;
function createTypeaheadQuery_1_0_0(data) {
    return {
        schema: "iglu:com.luxgroup/typeahead_query/jsonschema/1-0-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createTypeaheadQuery_1_0_0 = createTypeaheadQuery_1_0_0;
function createUpgrade_1_0_0(data) {
    return {
        schema: "iglu:com.luxgroup/upgrade/jsonschema/1-0-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createUpgrade_1_0_0 = createUpgrade_1_0_0;
function createUser_1_0_0(data) {
    return {
        schema: "iglu:com.luxgroup/user/jsonschema/1-0-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createUser_1_0_0 = createUser_1_0_0;
function createUserPurchaseCount_1_0_0(data) {
    return {
        schema: "iglu:com.luxgroup/user_purchase_count/jsonschema/1-0-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createUserPurchaseCount_1_0_0 = createUserPurchaseCount_1_0_0;
function createUtms_1_0_0(data) {
    return {
        schema: "iglu:com.luxgroup/utms/jsonschema/1-0-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createUtms_1_0_0 = createUtms_1_0_0;
function createVendor_1_0_0(data) {
    return {
        schema: "iglu:com.luxgroup/vendor/jsonschema/1-0-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createVendor_1_0_0 = createVendor_1_0_0;
function createZeroSearchResults_1_0_0(data) {
    return {
        schema: "iglu:com.luxgroup/zero_search_results/jsonschema/1-0-0",
        // casting hack to get this working with snowplow-sdk typescript definition
        data: data,
    };
}
exports.createZeroSearchResults_1_0_0 = createZeroSearchResults_1_0_0;
